import React, { useState } from 'react';
import { Form, Button, Modal } from 'react-bootstrap';
import { updateTickerTSize, updateAccountTickerTSize } from '../services/api';

const TSizeEditor = ({ tickerId, symbol, currentTSize, onTSizeChange, onClose, accountId }) => {
  const [tsize, setTSize] = useState(currentTSize?.toString() || '1');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const value = tsize === '' ? null : parseFloat(tsize);
      
      // Use account-specific endpoint if accountId is provided, otherwise use legacy endpoint
      if (accountId) {
        await updateAccountTickerTSize(tickerId, accountId, value);
      } else {
        await updateTickerTSize(tickerId, value);
      }
      
      // Call the callback to update the parent component
      if (onTSizeChange) {
        onTSizeChange(value);
      }
      
      onClose();
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to update target size');
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    onClose();
  };

  return (
    <Modal 
      show={true} 
      onHide={handleCancel} 
      centered
      backdrop={true}
      keyboard={true}
      size="sm"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          {symbol}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Control
              type="number"
              step="0.01"
              min="0"
              placeholder="Enter target size"
              value={tsize}
              onChange={(e) => setTSize(e.target.value)}
              autoFocus
            />
          </Form.Group>

          {error && (
            <div className="alert alert-danger mb-3">
              {error}
            </div>
          )}

          <div className="d-flex gap-2 justify-content-end">
            <Button 
              variant="outline-secondary"
              onClick={handleCancel}
              disabled={loading}
            >
              Cancel
            </Button>
            <Button 
              variant="primary" 
              type="submit"
              disabled={loading}
            >
              {loading ? 'Saving...' : 'Save'}
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default TSizeEditor; 